/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { emptyTrashNotifications } from '../fn/notification-api-message-center/empty-trash-notifications';
import { EmptyTrashNotifications$Params } from '../fn/notification-api-message-center/empty-trash-notifications';
import { getNotification } from '../fn/notification-api-message-center/get-notification';
import { GetNotification$Params } from '../fn/notification-api-message-center/get-notification';
import { GetNotificationByIdResponse } from '../models/get-notification-by-id-response';
import { getNotifications } from '../fn/notification-api-message-center/get-notifications';
import { GetNotifications$Params } from '../fn/notification-api-message-center/get-notifications';
import { getNotificationStats } from '../fn/notification-api-message-center/get-notification-stats';
import { GetNotificationStats$Params } from '../fn/notification-api-message-center/get-notification-stats';
import { GetNotificationStatsResponse } from '../models/get-notification-stats-response';
import { GetPagedNotificationsResponse } from '../models/get-paged-notifications-response';
import { postNotifications } from '../fn/notification-api-message-center/post-notifications';
import { PostNotifications$Params } from '../fn/notification-api-message-center/post-notifications';


/**
 * This lists and explains endpoints that relate to retrieving and updating notifications.
 */
@Injectable({ providedIn: 'root' })
export class NotificationApiMessageCenterApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getNotifications()` */
  static readonly GetNotificationsPath = '/notifications';

  /**
   * show a list of notifications for the logged-in user.
   *
   * show a list of notifications for the logged-in user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotifications$Response(params?: GetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPagedNotificationsResponse>> {
    return getNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * show a list of notifications for the logged-in user.
   *
   * show a list of notifications for the logged-in user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotifications(params?: GetNotifications$Params, context?: HttpContext): Observable<GetPagedNotificationsResponse> {
    return this.getNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPagedNotificationsResponse>): GetPagedNotificationsResponse => r.body)
    );
  }

  /** Path part for operation `postNotifications()` */
  static readonly PostNotificationsPath = '/notifications';

  /**
   * update notifications for the logged-in user.
   *
   * update notifications for the logged-in user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNotifications()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotifications$Response(params?: PostNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * update notifications for the logged-in user.
   *
   * update notifications for the logged-in user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNotifications$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotifications(params?: PostNotifications$Params, context?: HttpContext): Observable<void> {
    return this.postNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNotification()` */
  static readonly GetNotificationPath = '/notification/{notificationId}';

  /**
   * fetch the notification by notification Id.
   *
   * show the notification by notification Id for the logged-in user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotification$Response(params: GetNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationByIdResponse>> {
    return getNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * fetch the notification by notification Id.
   *
   * show the notification by notification Id for the logged-in user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotification(params: GetNotification$Params, context?: HttpContext): Observable<GetNotificationByIdResponse> {
    return this.getNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNotificationByIdResponse>): GetNotificationByIdResponse => r.body)
    );
  }

  /** Path part for operation `getNotificationStats()` */
  static readonly GetNotificationStatsPath = '/notifications/stats';

  /**
   * fetch stats for notifications.
   *
   * show the notification stats the logged-in user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationStats$Response(params?: GetNotificationStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationStatsResponse>> {
    return getNotificationStats(this.http, this.rootUrl, params, context);
  }

  /**
   * fetch stats for notifications.
   *
   * show the notification stats the logged-in user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationStats(params?: GetNotificationStats$Params, context?: HttpContext): Observable<GetNotificationStatsResponse> {
    return this.getNotificationStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNotificationStatsResponse>): GetNotificationStatsResponse => r.body)
    );
  }

  /** Path part for operation `emptyTrashNotifications()` */
  static readonly EmptyTrashNotificationsPath = '/notifications/trash/empty';

  /**
   * Empty trash for notifications for the logged-in user.
   *
   * Empty trash for notifications for the logged-in user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emptyTrashNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  emptyTrashNotifications$Response(params?: EmptyTrashNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return emptyTrashNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * Empty trash for notifications for the logged-in user.
   *
   * Empty trash for notifications for the logged-in user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `emptyTrashNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  emptyTrashNotifications(params?: EmptyTrashNotifications$Params, context?: HttpContext): Observable<void> {
    return this.emptyTrashNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
